import React, { useContext, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import DataContext from "../../../context/DataContext";
import TablePagination from "@mui/material/TablePagination";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import apiService from "../../../api/apiService";
import downloadExcel from "../../../hooks/downloadExcel";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import notifyService from "../../../api/notifySerivce";
import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, Grid, Modal, TextField, Tooltip } from "@mui/material";
import SendEmail from "../../admin-module/startup-page/SendEmail";
import { Controller, useForm } from "react-hook-form";
import CustomLink from "../../common-page/CustomLink";
import { IconButton } from "@mui/material";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {
    FirstPage,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    LastPage,
} from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import SendEmailAdmin from "../../admin-module/startup-page/SendEmailAdmin";
import { useNavigate } from "react-router-dom";

const SearchinputDiv = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "beige",
    "&:hover": {
        backgroundColor: "beige",
    },
    color: "black",
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(1),
        width: "auto",
    },
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            width: "23ch",
            "&:focus": {
                width: "25ch",
            },
        },
    },
}));

const DynamicFormList = () => {
    const { open, modalstyle, setPageLoading, tableIndexValue, isWhitespace } =
        useContext(DataContext);
    const [formData, setFormData] = useState({});
    const { handleSubmit, control, setValue, watch, reset, clearErrors, getValues, formState: { errors } } = useForm(
        { values: formData, }
    );
    const navigate = useNavigate();
    const [fundFormListData, setFundFormListData] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeStartup, setActiveStartup] = useState(1);
    const [acceptTanseed, setAcceptTanseed] = useState(true);
    const [searchInputValue, setSearchInputValue] = useState("");

    useDidMountEffect(() => {
        userCustomList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page,
        rowsPerPage,
        searchInputValue,
        activeStartup,
        acceptTanseed,
    ]);
    const [searchName, setSearchName] = useState("");
    const handleSearch = (searchValue) => {
        if (searchValue.length > 2) {
            setSearchInputValue(searchValue);
            setPage(0);
        } else {
            setSearchInputValue("");
            setPage(0);
        }
        setSearchName(searchValue);
    };
    const userCustomList = async () => {
        setPageLoading(true);
        setFundFormListData([]);
        var reqTanseed = {
            listSize: rowsPerPage,
            pageNumber: page + 1,
            searchString: searchInputValue,
        };
        await apiService("admin/custom/form/list", reqTanseed, "post").then(
            (res) => {
                setPageLoading(false);
                if (res) {
                    setCount(res.data.count);
                    if (res.data.fundFormList) {
                        setFundFormListData(res.data.fundFormList);
                    } else {
                        setFundFormListData([]);
                    }
                }
            }
        );
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

 


    const [openModal, setOpenModal] = useState(false);
    const handleOpenModal = () => {
        reset();
        setValue("name", "");
        setValue("path", "");
        setValue("startDate", null);
        setValue("endDate", null);
        setValue("description", "");
        setOpenModal(true);
    }
    const handleCloseModal = () => {
        setOpenModal(false);
        reset()
    };
    // const [getId, setGetId] = useState(0);
    const editValue = (id) => {
        setOpenModal(true);
        getApi(id);
        debugger
    }
    const getApi = (id) => {
        setPageLoading(true);
        apiService(`admin/custom/form/get?id=${id}`, '', 'get')
            .then((result) => {
                setPageLoading(false);
                if (result.data.startDate) {
                    result.data.startDate = dayjs(result.data.startDate, "DD-MM-YYYY");
                }
                if (result.data.endDate) {
                    result.data.endDate = dayjs(result.data.endDate, "DD-MM-YYYY");
                }
                debugger
                setFormData(result.data);
            })
            .catch((err) => {
                setPageLoading(false);
            });
    };
    const onSubmit = (data) => {
        if (data.startDate) {
            data.startDate = dayjs(data.startDate).format("YYYY-MM-DDTHH:mm:ss");
        }
        if (data.endDate) {
            data.endDate = dayjs(data.endDate).format("YYYY-MM-DDTHH:mm:ss");
        }
        data.id = data.id ? data.id : 0;
        apiService("admin/custom/form/save", data, "post").then((res) => {
            setPageLoading(false);
            if (res && res.data && res.data.responseStatus === "Success") {
                notifyService('success', 'Success', res.data.responseStatus);
                reset();
                setOpenModal(false);
                userCustomList()
            }
        });
    }
    const [startDate, setStartDate] = useState(null)
    const [selectedDate, setSelectedDate] = useState(false);
    const handleStartDateChange = (newValue) => {
        if (endDate && dayjs(newValue).isAfter(endDate)) {
            notifyService("danger", "Start Date cannot be after End Date");
            setStartDate(newValue);
            setValue("startDate", newValue);
            setEndDate(null); // Reset end date
            setValue("endDate", null); // Reset form value
            clearErrors(["startDate", "endDate"]);
            setSelectedDate(true);
        } else {
            setStartDate(newValue);
            setValue("startDate", newValue);
            clearErrors("startDate");
            setSelectedDate(false);
            setValue("endDate", null);
            setEndDate(null);
        }
    };

    const [endDate, setEndDate] = useState(null)
    const handleEndDateChange = (newValue) => {
        if (startDate && dayjs(newValue).isBefore(startDate)) {
            notifyService("danger", "End Date cannot be before Start Date");
            setValue("endDate", null);
            setEndDate(null);
            setSelectedDate(true);
        } else {
            setEndDate(newValue);
            setValue("endDate", newValue);
            clearErrors("endDate");
            setSelectedDate(false);
        }
    };

    // const [endDate, setEndDate] = useState(null)
    // const handleEndDateFormat = (newValue) => {
    //     setEndDate(newValue)
    //     setValue('endDate', newValue)
    //     clearErrors('endDate');
    // }
    const [isFullTextVisible, setIsFullTextVisible] = useState({})
    const toggleText = (index) => {
        debugger
        setIsFullTextVisible(prevState => ({
            ...prevState,
            [index]: !prevState[index],
        }));
        debugger
    };
    const truncateTexts = (text, charLimit) => {
        if (typeof text !== 'string') return ''; // Handle undefined, null, or non-string values
        return text.length > charLimit ? text.substring(0, charLimit) + ".." : text;
    };
    const [deleteModal, setDeleteModal] = useState(false);
    const handleDeleteCloseModal = () => {
        setDeleteModal(false)
    }
    const [deleteId, setDeleteId] = useState(0);
    const handleDeleteOpenModal = (id) => {
        setDeleteId(id)
        setDeleteModal(true)
    }
    const deleteUser = async () => {
        apiService(`admin/custom/form/remove?id=${deleteId}`, "", "delete").then((res) => {
            if (res) {
                if (res.data.responseStatus === "Success") {
                    notifyService("success", "Success", "Deleted successfully !!");
                    setDeleteModal(false)
                    userCustomList()
                }
            }
        });
    };
    return (
        <>
            <div className="scsthub-div form_div chart">
                <div className="table_tag">
                    <div className="table_header_tag set-res-flex ml-auto">
                        <SearchinputDiv
                            sx={{ display: { xs: "none", sm: "block" } }}
                            onChange={(e) => handleSearch(e.target.value)}
                        >
                            <SearchIconWrapper>
                                <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase
                                value={searchName}
                                type="search"
                                placeholder="Search by Funding Name	"
                                inputProps={{ "aria-label": "search" }}
                            />
                        </SearchinputDiv>
                        <div className="ml-auto">
                            <div className="d-flex align-item-center">
                                <Button className='ml-3'
                                    variant="contained" onClick={handleOpenModal}>Add Form</Button>
                            </div>
                        </div>
                    </div>
                    {fundFormListData.length ? (
                        <TableContainer component={Paper}>
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>No</TableCell>
                                        <TableCell>Funding Name</TableCell>

                                        <TableCell>Description</TableCell>
                                        <TableCell>Path Name</TableCell>
                                        <TableCell>Start Date</TableCell>
                                        <TableCell>End Date</TableCell>
                                        <TableCell className="text-center">Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {fundFormListData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {tableIndexValue(rowsPerPage, page, index)}
                                            </TableCell>
                                            <TableCell
                                                style={{
                                                    textDecoration: "none",
                                                    color: "#1976d2",
                                                    fontWeight: "600",
                                                }}
                                            >
                                             <span style={{cursor:'pointer'}} onClick={() =>
                                                    window.open(`/dynamic-form/userList/${btoa(row.id)}`, "_blank", "noopener,noreferrer")
                                                }>{row.name}</span>   
                                            </TableCell>


                                            <TableCell>
                                                {row.description ? (
                                                    <>
                                                        {isFullTextVisible[index]
                                                            ? row.description
                                                            : truncateTexts(row.description || '', 15)}

                                                        {row.description && row.description.length > 15 && (
                                                            <h6
                                                                onClick={() => toggleText(index)}
                                                                style={{ cursor: "pointer", color: "#7F9AD2", fontSize: '14px' }}
                                                            >
                                                                {isFullTextVisible[index] ? " Read Less" : " Read More"}
                                                            </h6>
                                                        )}
                                                    </>) : ((`-`))}
                                            </TableCell>
                                            <TableCell>{row.path ? row.path : `-`}</TableCell>
                                            <TableCell>{row.startDate ? row.startDate : `-`}</TableCell>
                                            <TableCell>{row.endDate ? row.endDate : `-`}</TableCell>
                                            <TableCell>
                                                <Tooltip title="Edit" placement="top">
                                                    <EditIcon
                                                        className="c-green c-pointer ml-5"
                                                        onClick={() => editValue(row.id)}
                                                    />
                                                </Tooltip>
                                                <Tooltip title="Remove" placement="top">
                                                    <DeleteSweepIcon
                                                        className="c-red c-pointer ml-2"
                                                        onClick={() => {
                                                            handleDeleteOpenModal(row.id);
                                                        }}
                                                    />
                                                </Tooltip>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                                <caption>
                                    <TablePagination
                                        component="div"
                                        count={count}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        style={{ float: "left" }}
                                        ActionsComponent={(paginationProps) => (
                                            <CustomTablePaginationActions {...paginationProps} />
                                        )}
                                    />
                                </caption>
                            </Table>
                        </TableContainer>
                    ) : (
                        <div className="nodata_tag">
                            <img
                                src="/images/Tanfundlogo-black-1.png"
                                className="no_data_logo"
                                alt=""
                            />
                            <h4>No Records Found</h4>
                        </div>
                    )}
                </div>
            </div>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth={"md"}
                fullWidth
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h4 className="p-3" style={{ fontWeight: '600', color: '#000' }}>Funding Form</h4>
                    </DialogContentText>
                    <form
                        className="signin-form"
                        onSubmit={handleSubmit(onSubmit)}
                    >
                        <Grid
                            container
                            direction="row"
                            alignItems="flex-start"
                            spacing={3}
                        >
                            <Grid item sm={12} md={6} lg={6}>
                                <div className="form-group mt-2">
                                    <Controller
                                        name="name"
                                        control={control}
                                        defaultValue=""
                                        rules={{
                                            required: "Funding Name is required",
                                            validate: {
                                                noWhitespace: (value) =>
                                                    !isWhitespace(value) || "Whitespace not allowed",
                                            },
                                        }}
                                        render={({ field }) => (
                                            <TextField
                                                variant="outlined"
                                                label="Funding Name *"
                                                placeholder="Enter Funding Name"
                                                fullWidth
                                                {...field}
                                            />
                                        )}
                                    />
                                    <FormHelperText className="text-danger">
                                        {errors.name && errors.name.message}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            {/* <Grid item sm={12} md={6} lg={6}>
                                <div className="form-group mt-2">
                                    <Controller
                                        name="path"
                                        control={control}
                                        defaultValue=""
                                        rules={{
                                            required: "Path is required",
                                            maxLength: {
                                                value: 10,
                                                message: "Maximum 10 characters allowed",
                                            },
                                            pattern: {
                                                value: /^[a-z,0-9]*$/,
                                                message: "Only lowercase letters (a-z) allowed",
                                            },
                                        }}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                variant="outlined"
                                                label="Path *"
                                                placeholder="Enter Path"
                                                fullWidth
                                                inputProps={{ maxLength: 10 }}
                                                onChange={(e) => {
                                                    // Convert to lowercase and remove non-alphabet characters
                                                    const value = e.target.value
                                                        .toLowerCase()
                                                        .replace(/[^a-z,0-9]/g, "")
                                                        .slice(0, 10); // truncate to max 10

                                                    field.onChange(value);
                                                }}
                                                value={field.value}
                                            />
                                        )}
                                    />
                                    <FormHelperText className="text-danger">
                                        {errors.path && errors.path.message}
                                    </FormHelperText>
                                </div>
                            </Grid> */}
                            <Grid item sm={12} md={6} lg={6}>
  <div className="form-group mt-2">
    <Controller
      name="path"
      control={control}
      defaultValue=""
      rules={{
        required: "Path Name is required",
        maxLength: {
          value: 15,
          message: "Maximum 15 characters allowed",
        },
        pattern: {
          value: /^[a-z0-9]*$/,
          message: "Only lowercase letters (a-z) and numbers (0-9) allowed",
        },
      }}
      render={({ field }) => (
        <>
          <TextField
            {...field}
            variant="outlined"
            label="Path Name *"
            placeholder="Enter Path Name"
            fullWidth
            inputProps={{ maxLength: 15 }}
            onChange={(e) => {
              const value = e.target.value
                .toLowerCase()
                .replace(/[^a-z0-9]/g, "")
                .slice(0, 15);
              field.onChange(value);
            }}
            value={field.value}
          />
          <div style={{ textAlign: "right", fontSize: "12px", color: "#888" }}>
            {field.value.length}/15
          </div>
        </>
      )}
    />
    <FormHelperText className="text-danger">
      {errors.path && errors.path.message}
    </FormHelperText>
  </div>
</Grid>

                            <Grid item sm={12} md={6} lg={6}>
                                <div className="form-group">
                                    <Controller
                                        name="startDate"
                                        control={control}
                                        rules={{ required: "Start Date is Required" }}
                                        render={({ field }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="Start Date *"
                                                    format="DD/MM/YYYY"
                                                    disablePast
                                                    value={startDate}
                                                    {...field}
                                                    sx={{ width: "100%" }}
                                                    onChange={(newValue) => {
                                                        handleStartDateChange(newValue);
                                                        field.onChange(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                    <FormHelperText className="text-danger">
                                        {errors.startDate && errors.startDate.message}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={6} lg={6}>
                                <div className="form-group">
                                    <Controller
                                        name="endDate"
                                        control={control}
                                        rules={{ required: "End Date is Required" }}
                                        render={({ field }) => (
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    label="End Date *"
                                                    format="DD/MM/YYYY"
                                                    disablePast
                                                    // minDate={startDate}
                                                    minDate={startDate || dayjs()}
                                                    value={endDate}
                                                    {...field}
                                                    sx={{ width: "100%" }}
                                                    onChange={(newValue) => {
                                                        handleEndDateChange(newValue);
                                                        field.onChange(newValue);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        )}
                                    />
                                    <FormHelperText className="text-danger">
                                        {errors.endDate && errors.endDate.message}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item sm={12} md={12} lg={12}>
                                <div className="input_background">
                                    <Controller
                                        name="description"
                                        control={control}
                                        defaultValue=""
                                        rules={{
                                            required: "Short Description is required",
                                            validate: {
                                                noWhitespace: (value) =>
                                                    !isWhitespace(value) || "Whitespace not allowed",
                                                maxLength: (value) =>
                                                    value.length <= 75 || "Maximum 75 characters allowed",
                                            },
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <TextField
                                                    variant="outlined"
                                                    label="Short Description *"
                                                    placeholder="Please Enter Short Description"
                                                    fullWidth
                                                    multiline
                                                    rows={4}
                                                    {...field}
                                                    inputProps={{ maxLength: 75 }}
                                                    helperText={`${field.value.length}/75`}
                                                    error={!!errors.description}
                                                />
                                                <FormHelperText className="text-danger">
                                                    {errors.description && errors.description.message}
                                                </FormHelperText>
                                            </>
                                        )}
                                    />
                                </div>
                            </Grid>

                        </Grid>
                        <DialogActions className="d-flex justify-content-center mb-2">
                            <Button
                                className="remove-api-modal-cancel"
                                onClick={handleCloseModal}
                            >
                                Close
                            </Button>
                            <Button className="remove-api-modal-confirm" type="submit" >
                                Save
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>

            </Dialog >
            <Dialog
                open={deleteModal}
                // onClose={handleApproveCloseModal}
                maxWidth={"sm"}
                fullWidth
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    <center>
                        <img src="/images/img/attention.gif" alt="" className="alert-image" />
                    </center>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h6 className="text-center p-3 text-dark">Are you sure you want to delete this form ?</h6>
                        <h5 className="text-center text-dark">Once deleted, it will be permanently removed from the Funding application form list.</h5>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="d-flex justify-content-center mb-2">
                    <Button
                        className="remove-api-modal-cancel"
                        onClick={handleDeleteCloseModal}
                    >
                        Cancel
                    </Button>
                    <Button className="remove-api-modal-confirm" onClick={deleteUser}>
                        Remove
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DynamicFormList;
function CustomTablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div style={{ flexShrink: 0, marginLeft: "1rem" }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPage />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                <LastPage />
            </IconButton>
        </div>
    );
}
